import type { CalculationResult } from "./model.js";

const LOCALE = "de-DE";

export function formatNumber(value: number): string {
  return value.toLocaleString(LOCALE, { maximumFractionDigits: 0 });
}

export function formatEuro(value: number): string {
  return `${formatNumber(Math.round(value))} €`;
}

export function formatPercent(value: number): string {
  return `${formatNumber(Math.round(value))} %`;
}

export function formatSquareMeters(value: number): string {
  return `${formatNumber(value)} m²`;
}

export function formatPayback(paybackSeasons: number): string {
  if (paybackSeasons <= 1) return "< 1 Saison";
  return `${paybackSeasons.toLocaleString(LOCALE, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} Saisons`;
}

export function formatStories(stories: number): string {
  return `${stories}-stöckig`;
}

/** Human readable copy of a result, used by the component and the sales email. */
export interface FormattedResult {
  prefix: string;
  rackCount: string;
  floorArea: string;
  stories: string;
  revenuePerSeason: string;
  investment: string;
  payback: string;
  absoluteReturn: string;
  roiPercent: string;
  /** "3-Jahres-ROI" */
  roiLabel: string;
}

/** Two decimals with a German comma, for prices. */
export function formatDecimal(value: number): string {
  return value.toLocaleString(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatResult(result: CalculationResult): FormattedResult {
  const prefix = result.isCappedEstimate ? "mind. " : "";
  return {
    prefix,
    rackCount: prefix + formatNumber(result.rackCount),
    floorArea: prefix + formatSquareMeters(result.floorArea),
    stories: formatStories(result.stories),
    revenuePerSeason: prefix + formatEuro(result.revenuePerSeason),
    investment: prefix + formatEuro(result.investment),
    payback: formatPayback(result.paybackSeasons),
    absoluteReturn: prefix + formatEuro(result.absoluteReturn),
    roiPercent: prefix + formatPercent(result.roiPercent),
    roiLabel: `${result.roiYears}-Jahres-ROI`,
  };
}
